<template>
  <main>
    <AgendaModal ref="AgendaModal"></AgendaModal>
    <div class="work-container">
      <div class="work-head">
        <div class="work-head-left">
          <div class="work-title">Liste des devoirs</div>

          <div class="input-field work-type-style">
            <select v-model="filter">
              <option value="toCome">à venir</option>
              <option value="past">passés</option>
            </select>
          </div>
        </div>
        <div class="work-head-right">
          <!--<div class="whr-button-left">
            <div class="input-field work-search-style">
              <i class="material-icons prefix">search</i>
              <input
                type="text"
                placeholder="Rechercher..."
                id="autocomplete-input"
                class="autocomplete"
                v-model="search"
              />
            </div>
          </div>-->
          <div
            class="whr-button-right"
            v-if="
              userProfile.permissions != undefined &&
              userProfile.permissions.includes('studenttemp')
            "
          >
            <a
              class="waves-effect waves-teal btn-flat"
              @click="$refs.AgendaModal.openModal()"
            >
              <i class="material-icons left">add</i>Ajouter un travail
            </a>
          </div>
        </div>
      </div>
      <div class="table-background">
        <transition name="fade" mode="out-in">
          <table class="striped" v-bind:key="Object.keys(homeworksForGroup(homeworks)).length">
            <thead>
              <tr>
                <th>
                  <i class="material-icons-outlined prefix">label</i>Intitulé
                </th>
                <th>
                  <i class="material-icons-outlined prefix">school</i>Matière
                </th>
                <th><i class="material-icons-outlined prefix">today</i>Date</th>
                <th>
                  <i class="material-icons-outlined prefix">schedule</i>Heure
                </th>
                <th>
                  <i class="material-icons-outlined prefix">grading</i>Notation
                </th>
                <th>
                  <i class="material-icons-outlined prefix">local_shipping</i
                  >Remise
                </th>
                <th>
                  <i class="material-icons-outlined prefix">delete</i>Actions
                </th>
              </tr>
            </thead>

            <tbody>
              <tr
                class="hoverable"
                v-for="(homework, id) of homeworksForGroup(homeworks)"
                v-bind:key="id"
                :id="id"
              >
                <td
                  v-html="
                    '<ul class=\'browser-default\'><li>' +
                    homework.label.join('</li><li>') +
                    '</li></ul>'
                  "
                ></td>
                <td>
                  {{
                    modules.hasOwnProperty(homework.module)
                      ? homework.module +
                        " - " +
                        (modules[homework.module].shortName
                          ? modules[homework.module].shortName
                          : modules[homework.module].name)
                      : homework.module
                  }}
                </td>
                <!--<td>{{homework.group}}</td>-->
                <td>{{ homework.date }}</td>
                <td>{{ homework.time }}</td>
                <td>
                  {{
                    homework.notation == "graded"
                      ? "Noté"
                      : homework.notation == "notGraded"
                      ? "Non noté"
                      : "Non renseigné"
                  }}
                </td>
                <td>
                  <a :href="homework.link" v-if="homework.link != ''">{{
                    homework.delivery
                  }}</a>
                  <p v-else>{{ homework.delivery }}</p>
                </td>
                <td>
                  <a @click="deleteWork(id)">Supprimer</a>
                </td>
              </tr>
              <tr v-if="Object.keys(homeworksForGroup(homeworks)).length == 0">
                <td colspan="7">
                  <transition name="fade" mode="out-in">
                    <div class="noItem inline" v-bind:key="filter">
                      <i class="material-icons-outlined">book</i
                      >{{
                        filter == "toCome"
                          ? "Aucun devoir pour l'instant"
                          : "L'historique des devoirs passés est vide"
                      }}
                    </div>
                  </transition>
                </td>
              </tr>
            </tbody>
          </table>
        </transition>
        <!--<h4>Recherche : {{ search }}</h4>-->
      </div>
    </div>
    <div
      class="fixed-action-btn"
      v-if="
        userProfile.roles != undefined &&
        userProfile.roles.includes('moderator')
      "
    >
      <a class="btn-floating btn-large" @click="$refs.AgendaModal.openModal()">
        <i class="large material-icons">add</i>
      </a>
    </div>

    <div id="modal1" class="modal modal-delete">
      <div class="modal-head">
        <h4>Suppression du devoir</h4>
      </div>
      <div class="modal-content">
        <p v-if="workToDelete != null">
          Voulez vous vraiment supprimer le devoir pour le module "{{
            homeworksForGroup(homeworks)[workToDelete]["module"]
          }}" ?
        </p>
      </div>
      <div class="modal-footer">
        <a href="#!" class="modal-close waves-effect waves-green btn-flat"
          >Non, annuler</a
        >
        <a
          @click="confirmDeleteWork()"
          class="modal-close waves-effect waves-red btn-flat"
          >Oui, le supprimer</a
        >
      </div>
    </div>
  </main>
</template>

<style>
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.work-container {
  /*padding: 40px 80px 40px 80px;*/
  margin: 20px auto;
  width: 90%;
}

.work-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.work-head .input-field {
  margin: 0;
}

.work-head-left {
  display: flex;
  padding-left: 20px;
  padding-bottom: 5px;
  font-size: 30px;
  font-weight: normal;
  color: #afdab9;
}

.work-head-left .work-type-style {
  margin-left: 20px;
  margin-top: 9px;
  padding-left: 10px;
  padding-right: 3px;
  width: 98px;
  height: 30px;
  border-radius: 20px;
  background-color: #afdab9;
}

.work-head-left .select-wrapper input.select-dropdown {
  height: 27px;
  border-bottom: none;
  font-size: 20px;
  color: white;
}

.work-head-left .select-wrapper input.select-dropdown:focus {
  border-bottom: none;
}

.work-head-left .select-wrapper .caret {
  top: 3px;
  fill: white;
}

.work-head-right {
  display: flex;
}

.work-head-right input[type="text"]:not(.browser-default) {
  margin: 0;
  margin-left: 40px;
  height: 30px;
  border-bottom: none;
}

.work-head-right
  input[type="text"]:not(.browser-default):focus:not([readonly]) {
  border-bottom: none;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.work-search-style {
  border: 3px solid #999;
}

.work-head .work-head-right .input-field .prefix {
  top: 2px;
  left: 8px;
  color: #999;
}

.input[type="text"]:not(.browser-default):focus:not([readonly]) {
  border-bottom: none;
}

.waves-effect.waves-teal .waves-ripple {
  background-color: #bfddc6;
}

.btn-flat {
  padding-left: 10px;
  padding-right: 20px;
}

.btn-flat,
.btn-flat i {
  text-transform: none;
  font-size: 18px;
}

.work-head-right .btn-flat i.left {
  margin-right: 2px;
  font-size: 25px;
}

.whr-button-left {
  margin: 0 20px 0 20px;
}

.whr-button-right {
  margin: 0 20px 0 0;
}

.work-head-right .whr-button-left .input-field .prefix ~ input {
  width: 105px;
}

@media only screen and (max-width: 1300px) {
  .work-head-left {
    padding-left: 20px;
    padding-bottom: 5px;
    font-size: 25px;
  }
  .work-head-left .work-type-style {
    width: 80px;
    margin-top: 5px;
  }
  .work-head-left .select-wrapper input.select-dropdown {
    height: 27px;
    font-size: 14px;
  }
  .work-head-right .whr-button-left .input-field .prefix {
    font-size: 25px;
  }
  .work-head-right .whr-button-left .input-field .prefix ~ input {
    width: 90px;
  }
  .btn-flat {
    font-size: 14px;
    padding-left: 5px;
    padding-right: 10px;
  }
  .btn-flat i {
    font-size: 20px;
  }
  .whr-button-right {
    margin: 0 10px 0 0;
  }
  .whr-button-left {
    margin: 0 10px 0 10px;
  }
  input[type="text"]:not(.browser-default) {
    font-size: 14px;
  }
  .work-head-right input[type="text"]:not(.browser-default) {
    height: 26px;
  }
}

@media only screen and (max-width: 1180px) {
  .work-head {
    flex-direction: column;
    align-items: flex-start;
  }
  .work-head-right {
    width: 100%;
    justify-content: space-between;
  }
  .work-head-right .whr-button-left .input-field .prefix ~ input {
    width: 110px;
  }
}

.table-background {
  overflow-x: auto;
}

.table-background table {
  background-color: white;
  border-radius: 16px 16px 0 0;
  overflow: hidden;
}

.table-background table thead {
  background-color: #afdab9;
}
.table-background table thead th {
  text-align: center;
  border-radius: 0;
  color: white;
}

.table-background table thead th:nth-last-child(n + 2) {
  border-right: 1px solid #9acca6;
}

.table-background table thead th i {
  vertical-align: -28%;
  margin-right: 5px;
}

.table-background table tbody {
  border-right: 2px solid #ddd;
}

.table-background table tbody td {
  padding: 15px 15px;
}

.table-background table tr td {
  border: 1px solid #ddd;
}

.table-background table tr td:hover {
  cursor: pointer;
}
</style>
<script>
import AgendaModal from "@/components/AgendaModal";
import M from "materialize-css";
import { mapState } from "vuex";

export default {
  components: {
    AgendaModal,
  },
  data() {
    return {
      homeworks: [],
      filter: "toCome",
      search: "",
      today: new Date(),
      deleteModal: null,
      workToDelete: null,
    };
  },
  computed: {
    ...mapState(["modules", "userProfile", "agendaRef"]),
  },
  watch: {
    agendaRef() {
      this.update();
    },
  },
  mounted() {
    var options = {};
    this.deleteModal = M.Modal.init(
      document.querySelector(".modal.modal-delete"),
      options
    );
    if (this.agendaRef != null) this.update();
  },
  methods: {
    update() {
      var elems = document.querySelectorAll("select");
      var instances = M.FormSelect.init(elems);
      var self = this;
      this.agendaRef.on("value", function (snapshot) {
        self.homeworks = snapshot.val();
      });
    },
    addWork() {
      var newWorkRef = this.agendaRef.push();
      newWorkRef.set({
        date: "2020-10-05",
        delivery: "Remise Moodle",
        group: "prime",
        label: ["Devoir de test"],
        link: "https://google.fr",
        module: "M3101",
        notation: null,
        time: "23:30",
      });
    },
    deleteWork(id) {
      this.workToDelete = id;
      this.deleteModal.open();
    },
    confirmDeleteWork() {
      if (this.workToDelete != null) {
        var id = this.workToDelete;
        this.workToDelete = null;
        if (this.agendaRef.child(id).remove()) {
          M.toast({ html: "Devoir supprimé !" });
        }
      }
    },
    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    homeworksForGroup(homeworks) {
      var filtered = {};
      for (var id in homeworks) {
        if (
          (homeworks[id].group == "") | (homeworks[id].group == "prime") &&
          ((homeworks[id].date < this.formatDate(this.today) &&
            this.filter == "past") ||
            (homeworks[id].date >= this.formatDate(this.today) &&
              this.filter != "past"))
        )
          filtered[id] = homeworks[id];
      }
      return filtered;
    },
    filterByValue(array, string) {
      return array.filter((o) =>
        Object.keys(o).some((k) =>
          o[k].toLowerCase().includes(string.toLowerCase())
        )
      );
    },
  },
};
</script>